import adaIcon from '_assets/ada/ada.svg';
import catIcon from '_assets/ada/cat.svg';

import { TChatConfig, TChatIconCode } from './types/entity';

export type TChatIconProps = {
  label: string;
  src: string;
};

export const CHAT_ICON_CODES: TChatIconCode[] = ['ADA', 'CAT'];

export const MAX_QUESTION_CHARS = 500;

export const WELCOME_MESSAGE_ID = 'welcome';

export const getChatIconPropsByCode = (
  code: null | TChatIconCode,
): TChatIconProps => {
  switch (code) {
    case 'CAT':
      return { label: 'Chat', src: catIcon };
    case 'ADA':
    default:
      return { label: 'Ada', src: adaIcon };
  }
};

const matchesPattern = (
  pattern: null | string,
  url: string,
): boolean | undefined => {
  if (!pattern?.trim()) return undefined;

  try {
    return new RegExp(pattern).test(url);
  } catch {
    return undefined;
  }
};

export const isChatAllowedOnUrl = (
  url: string,
  { excludePatterns, includePatterns }: TChatConfig,
): boolean =>
  matchesPattern(excludePatterns, url) !== true &&
  matchesPattern(includePatterns, url) !== false;
